import { isPlainObject } from 'is-plain-object';
import { DeepPartial } from 'types';
import merge from 'utils/deepmerge';
import { VideoTemplateStateContent } from '../types';

const overwriteMerge = (_, src) => src;

/**
 * create new state by deep merging mods into state.  changes are recorded
 * in the `patch` key
 */
export function updateState(
  state: VideoTemplateStateContent,
  mods: DeepPartial<VideoTemplateStateContent>,
): VideoTemplateStateContent {
  return merge(
    state,
    {
      patch: mods,
      ...mods,
    },
    {
      arrayMerge: overwriteMerge,
      isMergeableObject: isPlainObject,
    },
  );
}
